export default {"src":"/_next/static/image/public/images/verify_success.aa096dcedf40a27ec49b61524d57e7ac.svg","height":148,"width":142};